import type { DefCampo } from '../../componentes/formulario';
import type { EmpresasDaSessao } from '../sessao';

/**
 * V2 verticais (ficha 2026-10-20): Financeiro, Contas, Compras, Folha e Assinaturas seguem separados por empresa. Sem filtro
 * na aba e com mais de uma empresa permitida, o registro novo sem pai (de onde a empresa viria) pede a empresa no
 * formulário; a escolhida vai no cabeçalho `X-Empresa` da gravação (`cabecalhoEmpresa`). Com o filtro numa empresa, ou com
 * uma só, o campo não aparece e vale a da aba.
 */
export const precisaEscolherEmpresa = (e: EmpresasDaSessao | undefined) => !!e && !e.atual && e.opcoes.length > 1;

/** Nome do campo no formulário (fora do corpo enviado). */
export const CAMPO_EMPRESA = '_empresa_registro';

/** O campo "Empresa" (obrigatório) quando a aba não tem uma; senão, nenhum. */
export function campoEmpresaDoRegistro(e: EmpresasDaSessao | undefined, textos: { rotulo: string; ajuda: string }, extra: Partial<DefCampo> = {}): DefCampo[] {
  if (!precisaEscolherEmpresa(e)) return [];
  return [
    {
      nome: CAMPO_EMPRESA,
      rotulo: textos.rotulo,
      tipo: 'selecao',
      obrigatorio: true,
      largura: 'meia',
      ajuda: textos.ajuda,
      opcoes: e!.opcoes.map((o) => ({ valor: o.id, rotulo: o.nome })),
      ...extra,
    },
  ];
}

/** A empresa escolhida no formulário (vazia quando o campo não apareceu: vale a da aba). */
export const empresaEscolhida = (valores: Record<string, unknown>) => (typeof valores[CAMPO_EMPRESA] === 'string' && valores[CAMPO_EMPRESA] ? (valores[CAMPO_EMPRESA] as string) : null);

/**
 * Rodada rval1-1 (RVAL1-ROB-M2): telas cujo conteúdo inteiro é de uma empresa (configuração do REP-P, conectores por
 * empresa, Conta Azul, provedor de cobrança da empresa). Com a troca de empresa desligada no workspace não há seletor:
 * quem vê mais de uma empresa escolhe a da tela num campo dela (o mesmo `X-Empresa` de gravação). Com a troca ligada, nada
 * muda (vale o filtro do topo); com uma empresa só, ela já vem escolhida.
 */
export const precisaEmpresaNaTela = (e: EmpresasDaSessao | undefined) => !!e && e.troca === false && !e.atual && e.opcoes.length > 1;

/** A empresa que vale na tela: a atual (filtro ou única) ou, sem ela, a escolhida no campo da tela (vazia = nenhuma). */
export const empresaDaTela = (e: EmpresasDaSessao | undefined, escolhida: string | null | undefined) => e?.atual ?? (precisaEmpresaNaTela(e) && escolhida ? escolhida : null);
